<router-outlet></router-outlet>

<div class="row">
  <div class="col-12">
    @if (loading) {
      <wre-toolkit-loader></wre-toolkit-loader>
    } @else {
      @if (error) {
        <div class="p-3">Failed to retrieve the overview access users.</div>
      } @else {
        @if (accessMappings.length === 0) {
          <div class="col-12 text-start">
            <div class="fw-bold">No data to display.</div>
          </div>
        } @else {
          @if (srtOverviewListService.isNoSearchOrFilterResult) {
            <div class="no-results">
              No items were found based on your search criteria. Please try again.
            </div>
          } @else {
            @if (total > 0) {
              <div>
                <wre-srt-access-overview-table></wre-srt-access-overview-table>
                <div class="custom-pagination">
                  <wre-toolkit-pagination
                    [total$]="total$"
                    [(pageSize)]="srtOverviewListService.pageSize"
                    [(page)]="srtOverviewListService.page"
                    [isLoading]="loading">
                  </wre-toolkit-pagination>
                </div>
              </div>
            }
          }
        }
      }
    }
  </div>
</div>
